import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ commit }, payload) => {
  try {
    const { data } = await services.perfis.get_all(payload);
    commit(types.LIST_PERFIS, data.data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.perfis.show({ id: id }).then(res => {
    dispatch("ActionSetPrefil", res.body);
  });
};

export const ActionSave = async ({ dispatch, commit }, payload) => {
  commit(types.SET_LOADING, true);
  const action = !!payload.id ? "ActionUpdate" : "ActionStore"

  await dispatch(action, payload);


  commit(types.SET_LOADING, false);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.perfis.store(payload).then((res) => {
    commit(types.SET_PERFIL, res.data);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.perfis.update({ id: payload.id }, payload);
};

export const ActionGetAllCategories = async ({ commit }, payload) => {
  try {
    const { data } = await services.perfis.get_categorias(payload);
    commit(types.LIST_CATEGORIAS, data.data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const ActionSetPrefil = ({ commit }, payload) => {
  commit(types.SET_PERFIL, payload);
};

export const ActionResetProfile = ({ commit }, payload) => {
  const cliente = {
    pessoa_juridica: {},
    pessoa_fisica: {},
    endereco: {
      cep: "",
      logradouro: "",
      numero: null,
      complemento: null,
      bairro: "",
      uf: null,
      cidade_id: null,
    },
    parceiro_id: null,
    parceiro: {},
    contatos: {
      emails: [],
      telefones: [],
      redes_sociais: [],
    },
    clientePlanos: [],
  };

  commit(types.SET_PERFIL, cliente)
}
